import { render, staticRenderFns } from "./StockViewInvoice.vue?vue&type=template&id=4832f5da&scoped=true"
import script from "./StockViewInvoice.vue?vue&type=script&lang=js"
export * from "./StockViewInvoice.vue?vue&type=script&lang=js"
import style0 from "./StockViewInvoice.vue?vue&type=style&index=0&id=4832f5da&prod&scoped=true&lang=css"
import style1 from "./StockViewInvoice.vue?vue&type=style&index=1&id=4832f5da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4832f5da",
  null
  
)

export default component.exports